import { Component } from '@angular/core';
import { FileService } from '@app/services/files/file.service';

@Component({
  selector: 'app-fileupload',
  templateUrl: './fileupload.component.html'
})
export class FileuploadComponent {

  fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  editorContent;

  constructor(private fileService: FileService) { }

  fileProgress(fileInput: any) {

    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }

  preview() {
    const mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (_event) => {
      this.previewUrl = reader.result;
    };
  }

  onSubmit() {
    const formData = new FormData();
    formData.append('uploadedFile', this.fileData);
    formData.append('originatingId', '6730');
    this.fileService.UploadMemberImage(formData).subscribe(_ => {

    });
  }
}
